package br.com.texeratx.boardgametimeapp.ui.screens.active_match

data class ActiveMatchStatsUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
    val gameId: Long? = null,
    val stats: ActiveMatchGameStats? = null
)

data class ActiveMatchGameStats(
    val bestScore: Double?,
    val averageScore: Double?,
    val worstWinningScore: Double?,
    val topWinnerName: String?,
    val topWinnerWins: Int,
    val avgDurationMin: Int?,
    val minDurationMin: Int?,
    val maxDurationMin: Int?
)
